import './style.scss';
import React from 'react';
import classNames from 'classnames';
import { Pagination } from 'antd';
import { formatNumber } from '../../../utils/formatter';
import { PAGE_SIZE_OPTIONS } from '../../../constants/common';

/**
 * 对antd分页插件封装
 * */
export default function BasePagination(props) {
    const { onChange, className = '', ...others } = props;

    // 公共的props
    const defaultProps = {
        showTotal: total => (
            <span>
                共：<strong>{formatNumber(total)}</strong> 条
            </span>
        ),
        pageSizeOptions: PAGE_SIZE_OPTIONS,
        showSizeChanger: true,
        showQuickJumper: true
    };
    const pageChange = function(pageNum, pageSize = props.pageSize) {
        onChange && onChange(pageSize === props.pageSize ? pageNum : 1, pageSize);
    };

    const pageProps = { ...defaultProps, ...others };

    return (
        <div className={classNames('base-pagination', className, 'clearfix')}>
            {props.total ? <Pagination {...pageProps} onChange={pageChange} onShowSizeChange={pageChange} /> : null}
        </div>
    );
}



// WEBPACK FOOTER //
// ./src/components/common/pagination/Pagination.jsx